export const EMAIL_REGEXP = new RegExp(
  /^([_0-9A-Za-z.-]+)@((\[[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const PHONE_REGEXP = new RegExp(/^[0-9+()\s]+$/);
